import { render, staticRenderFns } from "./1200_custom-Smishing.vue?vue&type=template&id=22293f2d&scoped=true&lang=pug"
var script = {}
import style0 from "./1200_custom-Smishing.vue?vue&type=style&index=0&id=22293f2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22293f2d",
  null
  
)

export default component.exports